import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {
    Box,
    Typography,
} from '@mui/material';
import React from 'react';
import ProgressSurveyCta, { areSessionsCompletedUpTo } from '../ProgressSurveyCta';
import GrowthReportEnqueueButton, { ProgramWeek } from '../growth-report/GrowthReportEnqueueButton';
import { LessonPlanRole, LessonPlanSessionModel } from '../../object-actions/types/types';

interface LessonPlanMilestoneActionsProps {
    week: ProgramWeek;
    lessonPlanId: number;
    sessions: LessonPlanSessionModel[];
    myRoles?: LessonPlanRole[];
    paymentAssignmentId: number | null;
    onMessage: (message: string, severity: 'success' | 'error') => void;
}

/** Survey + growth-report CTAs for a checkpoint week (footer of sessions 4 / 8 / 12). */
export const LessonPlanMilestoneActions: React.FC<LessonPlanMilestoneActionsProps> = ({
    week,
    lessonPlanId,
    sessions,
    myRoles,
    paymentAssignmentId,
    onMessage,
}) => {
    const isUnlocked = areSessionsCompletedUpTo(sessions, week);
    const canManageReports =
        myRoles?.includes('coach') || myRoles?.includes('parent') || myRoles?.includes('payer');

    if (!isUnlocked) {
        return (
            <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: 'text.secondary' }}
                data-testid={`lesson-plan-session-milestone-locked--week-${week}`}
            >
                <LockOutlinedIcon fontSize="small" />
                <Typography variant="caption">Complete sessions 1–{week} to unlock</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <ProgressSurveyCta
                lessonPlanId={lessonPlanId}
                weekNum={week}
                sessions={sessions}
                myRoles={myRoles}
            />
            {canManageReports && paymentAssignmentId != null && (
                <GrowthReportEnqueueButton
                    paymentAssignmentId={paymentAssignmentId}
                    week={week}
                    onMessage={onMessage}
                />
            )}
        </Box>
    );
};

export default LessonPlanMilestoneActions;
